// СГЕНЕРИРОВАНО генератором миссий (developer_artifacts/scripts/missionGen).
// Правится не руками, а перегенерацией: npx tsx developer_artifacts/scripts/missionGen/generate_humans_8.cjs
/* eslint-disable */
const mission = {
  "id": "humans_8",
  "campaignFactionId": "humans",
  "order": 8,
  "title": "Вечный город",
  "shortTitle": "Миссия VIII",
  "description": "Возьми Рим, не убив его: клоака, предместья и счёт вслух",
  "finalRound": 11,
  "reward": {
    "type": "faction",
    "factionId": "dwarves"
  },
  "rewardIfFactionOwned": {
    "type": "chest",
    "chestId": "chest_random_legendary"
  },
  "playerColor": "blue",
  "players": [
    {
      "name": "Луций",
      "color": "blue",
      "factionId": "humans",
      "selectedSkin": "humans_default",
      "isBot": false,
      "bonus": "none"
    },
    {
      "name": "Дом Весов: гвардия",
      "color": "orange",
      "factionId": "ventory",
      "selectedSkin": "ventory_default",
      "isBot": true,
      "bonus": "none"
    },
    {
      "name": "Когорты Суллы",
      "color": "violet",
      "factionId": "humans",
      "selectedSkin": "humans_default",
      "isBot": true,
      "bonus": "none"
    },
    {
      "name": "Предместья",
      "color": "dark_green",
      "factionId": "humans",
      "selectedSkin": "humans_default",
      "isBot": true,
      "bonus": "none"
    }
  ],
  "field": {
    "hexes": {
      "-6,-3": "sea",
      "-6,-2": "sea",
      "-5,-2": "sea",
      "-5,-1": "sea",
      "-5,0": "sea",
      "-4,0": "sea",
      "-4,1": "sea",
      "-4,2": "sea",
      "-4,3": "sea",
      "-5,4": "sea",
      "-5,5": "sea",
      "-5,6": "sea",
      "-5,7": "sea",
      "-4,7": "sea",
      "-4,8": "sea",
      "-3,8": "sea",
      "-3,9": "sea",
      "-4,4": "mountain",
      "-3,-1": "mountain",
      "-3,4": "mountain",
      "-2,-2": "mountain",
      "-2,4": "ruins",
      "-1,-3": "mountain",
      "-1,4": "mountain",
      "0,-4": "road",
      "0,4": "road",
      "1,-4": "mountain",
      "1,3": "mountain",
      "2,-4": "mountain",
      "2,2": "mountain",
      "3,-4": "mountain",
      "3,1": "mountain",
      "4,-4": "mountain",
      "4,-3": "mountain",
      "4,-2": "mountain",
      "4,-1": "mountain",
      "4,0": "mountain",
      "-2,3": "ruins",
      "0,5": "road",
      "0,3": "road",
      "0,-1": "road",
      "1,-1": "road",
      "-1,0": "road",
      "-2,2": "road",
      "-1,2": "road",
      "-1,1": "road",
      "1,-2": "flag_violet",
      "2,-2": "quarter",
      "2,-3": "quarter",
      "0,-2": "farm",
      "1,-3": "farm",
      "2,-1": "farm",
      "0,0": "central_quarter_orange",
      "0,1": "quarter",
      "1,0": "farm",
      "-2,0": "flag_orange",
      "-3,1": "quarter",
      "-2,1": "quarter",
      "-2,-1": "quarter",
      "-3,0": "farm",
      "-1,-1": "farm",
      "4,3": "flag_dark_green",
      "3,4": "quarter",
      "5,2": "quarter",
      "4,4": "quarter",
      "3,3": "farm",
      "5,3": "farm",
      "4,2": "farm",
      "5,4": "barracks",
      "1,-6": "central_quarter_dark_green",
      "0,-5": "quarter",
      "1,-5": "quarter",
      "0,-6": "farm",
      "2,-6": "farm",
      "0,7": "flag_blue",
      "-1,8": "quarter",
      "1,6": "quarter",
      "0,6": "quarter",
      "-1,7": "farm",
      "1,7": "farm",
      "-1,6": "farm",
      "2,6": "farm",
      "-1,9": "farm",
      "0,8": "barracks",
      "-2,6": "road",
      "-3,6": "road",
      "-3,5": "ruins",
      "5,-5": "mountain",
      "5,-4": "mountain",
      "6,-6": "mountain",
      "6,-5": "mountain",
      "6,-4": "mountain",
      "7,-6": "mountain",
      "7,-5": "mountain",
      "-7,8": "mountain",
      "-7,9": "mountain",
      "-6,7": "mountain",
      "-6,8": "mountain",
      "-6,9": "mountain",
      "-5,8": "mountain",
      "-14,0": "sea",
      "-14,3": "sea",
      "-14,6": "sea",
      "-14,9": "sea",
      "-14,12": "sea",
      "-13,-1": "sea",
      "-12,14": "sea",
      "-10,-4": "sea",
      "-9,14": "sea",
      "-7,-7": "sea",
      "-6,14": "sea",
      "-4,-10": "sea",
      "-3,14": "sea",
      "-1,-13": "sea",
      "0,14": "sea",
      "2,-14": "sea",
      "3,11": "sea",
      "5,-14": "sea",
      "6,8": "sea",
      "8,-14": "sea",
      "9,5": "sea",
      "11,-14": "sea",
      "12,2": "sea",
      "14,-14": "sea",
      "14,-11": "sea",
      "14,-8": "sea",
      "14,-5": "sea",
      "14,-2": "sea",
      "-16,0": "sea",
      "-16,1": "sea",
      "-16,2": "sea",
      "-16,3": "sea",
      "-16,4": "sea",
      "-16,5": "sea",
      "-16,6": "sea",
      "-16,7": "sea",
      "-16,8": "sea",
      "-16,9": "sea",
      "-16,10": "sea",
      "-16,11": "sea",
      "-16,12": "sea",
      "-16,13": "sea",
      "-16,14": "sea",
      "-16,15": "sea",
      "-16,16": "sea",
      "-15,-1": "sea",
      "-15,16": "sea",
      "-14,-2": "sea",
      "-14,16": "sea",
      "-13,-3": "sea",
      "-13,16": "sea",
      "-12,-4": "sea",
      "-12,16": "sea",
      "-11,-5": "sea",
      "-11,16": "sea",
      "-10,-6": "sea",
      "-10,16": "sea",
      "-9,-7": "sea",
      "-9,16": "sea",
      "-8,-8": "sea",
      "-8,16": "sea",
      "-7,-9": "sea",
      "-7,16": "sea",
      "-6,-10": "sea",
      "-6,16": "sea",
      "-5,-11": "sea",
      "-5,16": "sea",
      "-4,-12": "sea",
      "-4,16": "sea",
      "-3,-13": "sea",
      "-3,16": "sea",
      "-2,-14": "sea",
      "-2,16": "sea",
      "-1,-15": "sea",
      "-1,16": "sea",
      "0,-16": "sea",
      "0,16": "sea",
      "1,-16": "sea",
      "1,15": "sea",
      "2,-16": "sea",
      "2,14": "sea",
      "3,-16": "sea",
      "3,13": "sea",
      "4,-16": "sea",
      "4,12": "sea",
      "5,-16": "sea",
      "5,11": "sea",
      "6,-16": "sea",
      "6,10": "sea",
      "7,-16": "sea",
      "7,9": "sea",
      "8,-16": "sea",
      "8,8": "sea",
      "9,-16": "sea",
      "9,7": "sea",
      "10,-16": "sea",
      "10,6": "sea",
      "11,-16": "sea",
      "11,5": "sea",
      "12,-16": "sea",
      "12,4": "sea",
      "13,-16": "sea",
      "13,3": "sea",
      "14,-16": "sea",
      "14,2": "sea",
      "15,-16": "sea",
      "15,1": "sea",
      "16,-16": "sea",
      "16,-15": "sea",
      "16,-14": "sea",
      "16,-13": "sea",
      "16,-12": "sea",
      "16,-11": "sea",
      "16,-10": "sea",
      "16,-9": "sea",
      "16,-8": "sea",
      "16,-7": "sea",
      "16,-6": "sea",
      "16,-5": "sea",
      "16,-4": "sea",
      "16,-3": "sea",
      "16,-2": "sea",
      "16,-1": "sea",
      "16,0": "sea"
    },
    "units": [
      {
        "id": "u_violet_0_2_-2",
        "hexKey": "2,-2",
        "ownerId": "player_id_violet",
        "type": "unit_d10",
        "size": 10,
        "maxSize": 10
      },
      {
        "id": "u_violet_1_2_-3",
        "hexKey": "2,-3",
        "ownerId": "player_id_violet",
        "type": "unit_d8",
        "size": 8,
        "maxSize": 8
      },
      {
        "id": "u_violet_2_1_-2",
        "hexKey": "1,-2",
        "ownerId": "player_id_violet",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_violet_3_1_-3",
        "hexKey": "1,-3",
        "ownerId": "player_id_violet",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_orange_4_0_0",
        "hexKey": "0,0",
        "ownerId": "player_id_orange",
        "type": "unit_d10",
        "size": 10,
        "maxSize": 10
      },
      {
        "id": "u_orange_5_-2_1",
        "hexKey": "-2,1",
        "ownerId": "player_id_orange",
        "type": "unit_d8",
        "size": 8,
        "maxSize": 8
      },
      {
        "id": "u_orange_6_-3_1",
        "hexKey": "-3,1",
        "ownerId": "player_id_orange",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_orange_7_-2_-1",
        "hexKey": "-2,-1",
        "ownerId": "player_id_orange",
        "type": "unit_d8",
        "size": 8,
        "maxSize": 8
      },
      {
        "id": "u_orange_8_0_4",
        "hexKey": "0,4",
        "ownerId": "player_id_orange",
        "type": "unit_d6",
        "size": 4,
        "maxSize": 6
      },
      {
        "id": "u_orange_9_0_-4",
        "hexKey": "0,-4",
        "ownerId": "player_id_orange",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_blue_10_0_6",
        "hexKey": "0,6",
        "ownerId": "player_id_blue",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      },
      {
        "id": "u_blue_11_-1_7",
        "hexKey": "-1,7",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_blue_12_1_6",
        "hexKey": "1,6",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_blue_13_-3_6",
        "hexKey": "-3,6",
        "ownerId": "player_id_blue",
        "type": "unit_d8",
        "size": 6,
        "maxSize": 8
      },
      {
        "id": "u_blue_14_1_7",
        "hexKey": "1,7",
        "ownerId": "player_id_blue",
        "type": "unit_d10",
        "size": 6,
        "maxSize": 10
      },
      {
        "id": "u_blue_15_0_8",
        "hexKey": "0,8",
        "ownerId": "player_id_blue",
        "type": "unit_d4",
        "size": 4,
        "maxSize": 4
      }
    ],
    "specialBuildings": {
      "2,-2": "fortress",
      "2,-3": "warehouse",
      "0,1": "guild",
      "-2,-1": "warehouse",
      "-1,8": "warehouse"
    },
    "gridConfig": {
      "radius": 20,
      "hexSize": 60,
      "orientation": "flat"
    }
  },
  "policyMarket": [
    {
      "id": "fanaticism",
      "name": "Фанатизм",
      "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
      "implemented": true
    },
    {
      "id": "agrarianism",
      "name": "Аграризм",
      "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
      "implemented": true
    },
    {
      "id": "isolationism",
      "name": "Изоляционизм",
      "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
      "implemented": true
    },
    {
      "id": "despotism",
      "name": "Деспотизм",
      "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
      "implemented": true
    },
    {
      "id": "militarism",
      "name": "Милитаризм",
      "description": "Увеличенный урон в ближнем бою",
      "implemented": true
    },
    {
      "id": "industrialism",
      "name": "Индустриализм",
      "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
      "implemented": true
    }
  ],
  "script": [
    {
      "id": "e_0_replica",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Я пишу это перед стенами города, в котором родился и которого не знаю. Отец учил меня, что Рим — это стены. Учитель — что Рим — это строй. Оба ошибались, и обоих я люблю за эти ошибки. Кому я пишу — скажу, когда допишу. Если доживу — прочту вслух.»",
        "characterName": "Из письма Луция",
        "side": "left",
        "characterImage": "/img/campaigns/humans/letters_lucius.png"
      }
    },
    {
      "id": "e_1_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h8_cloaca",
        "type": "unit_reaches_hex",
        "params": {
          "hexKey": "-2,3"
        },
        "text": "Проведи когорту клоакой к решётке (обоз идёт тропой берега)",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_2_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h8_burn_chamber",
        "type": "destroy_building",
        "params": {
          "hexKey": "0,1"
        },
        "text": "Сожги палату Весов (катапульта, 4 попадания)",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_3_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h8_break_guard",
        "type": "destroy_all_enemy_units",
        "params": {
          "color": "orange"
        },
        "text": "Разбей гвардию Дома (фактории у Тибра)",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_4_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h8_capitol",
        "type": "capture_city",
        "params": {
          "centralHexKey": "1,-2"
        },
        "text": "Освободи Капитолий: за стеной обоз не кормит — считай размер отрядов",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_5_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h8_senate_word",
        "type": "survive_rounds",
        "params": {
          "rounds": 11
        },
        "text": "Дождись слова сената (раунд 11)",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_6_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h8_army_lost",
        "type": "lose_all_units",
        "params": {},
        "text": "Армия не должна погибнуть",
        "isMain": false,
        "isFailure": true
      }
    },
    {
      "id": "entry_7_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_orange",
          "hexKey": "-2,0"
        }
      }
    },
    {
      "id": "entry_8_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_orange",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_9_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_violet",
          "hexKey": "1,-2"
        }
      }
    },
    {
      "id": "entry_10_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_violet",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_11_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_dark_green",
          "hexKey": "4,3"
        }
      }
    },
    {
      "id": "entry_12_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_dark_green",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_13_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true
          },
          "round": 0,
          "currentPlayerId": "player_id_dark_green",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_14_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Вход тут. Решётку я разогнул ещё в том месяце — ходил слушать, о чём говорят у контор. Свод низкий, вода по колено, идти — восемьсот шагов до ниши, потом направо и вверх, к воротной страже. Восемьсот. Шагов меньше, чем тогда, госпожа мама говорила — я считал до восьмисот сорока двух… Дойдём, легат. Это МАЛО шагов.",
        "characterName": "Ансгар",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m8_ansgar_guide.png"
      }
    },
    {
      "id": "e_15_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Когорта готова. Факелы гасим, идём по стене руки… Веди, проводник.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m8_atilius_calm.png"
      }
    },
    {
      "id": "e_16_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Подержи. Там темно — потеряю ещё.",
        "characterName": "Ансгар",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m8_ansgar_wolf.png"
      }
    },
    {
      "id": "e_17_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…Веди, проводник.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m8_lucius_quiet.png"
      }
    },
    {
      "id": "entry_18_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,0",
          "unitId": "u_orange_7_-2_-1",
          "unitHexKey": "-2,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_19_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_5_-2_1",
          "unitHexKey": "-2,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_20_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_21_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_6_-3_1",
          "unitHexKey": "-3,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_22_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_23_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_24_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-3",
          "unitId": "u_violet_1_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_25_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-3",
          "unitId": "u_violet_0_2_-2",
          "unitHexKey": "2,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_26_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,-2",
          "unitId": "u_violet_2_1_-2",
          "unitHexKey": "1,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_27_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,-1",
          "unitId": "u_violet_3_1_-3",
          "unitHexKey": "1,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_28_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_29_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_30_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true
          },
          "round": 1,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_31_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_32_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_33_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_34_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true
          },
          "round": 1,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_35_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_36_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_37_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_38_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_39_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_40_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_41_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_42_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_43_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_44_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_45_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 1,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_46_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true
          },
          "round": 1,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_47_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,0",
          "unitId": "u_orange_7_-2_-1",
          "unitHexKey": "-2,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_48_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_5_-2_1",
          "unitHexKey": "-2,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_49_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_50_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_6_-3_1",
          "unitHexKey": "-3,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_51_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_52_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_53_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-3",
          "unitId": "u_violet_1_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_54_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-3",
          "unitId": "u_violet_0_2_-2",
          "unitHexKey": "2,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_55_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,-2",
          "unitId": "u_violet_2_1_-2",
          "unitHexKey": "1,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_56_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,-1",
          "unitId": "u_violet_3_1_-3",
          "unitHexKey": "1,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_57_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_58_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_59_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true
          },
          "round": 2,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_60_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_61_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_62_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_63_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true
          },
          "round": 2,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_64_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_65_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_66_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_67_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_68_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_69_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_70_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_71_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_72_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_73_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_74_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 2,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_75_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fortificationism",
            "name": "Фортификационизм",
            "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
            "implemented": true
          },
          "round": 2,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "e_76_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Ворота НАШИ, легат! Стража сложила железо — половина, как Ансгара увидела, по именам его звала! Он им, оказывается, всю зиму рыбу носил, представляешь?!",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m8_atilius_calm.png"
      }
    },
    {
      "id": "e_77_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Представляю… Армия — в город! Кварталов не жечь, лавок не трогать: мы пришли ДОМОЙ, и дом это запомнит!",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m8_lucius_command.png"
      }
    },
    {
      "id": "entry_78_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,0",
          "unitId": "u_orange_7_-2_-1",
          "unitHexKey": "-2,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_79_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_5_-2_1",
          "unitHexKey": "-2,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_80_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_81_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_6_-3_1",
          "unitHexKey": "-3,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_82_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_83_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_84_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-3",
          "unitId": "u_violet_1_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_85_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-3",
          "unitId": "u_violet_0_2_-2",
          "unitHexKey": "2,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_86_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,-2",
          "unitId": "u_violet_2_1_-2",
          "unitHexKey": "1,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_87_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,-1",
          "unitId": "u_violet_3_1_-3",
          "unitHexKey": "1,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_88_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_89_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_90_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true
          },
          "round": 3,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_91_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_92_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_93_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_94_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true
          },
          "round": 3,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_95_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_96_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_97_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_98_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_99_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_100_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_101_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_102_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_103_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_104_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_105_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 3,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_106_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true
          },
          "round": 3,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "e_107_replica",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Вы меня знаете. Я — Ильва. Я вам рыбу вялила, долги считала, детей ваших от жара отпаивала. Я не римлянка. Мой муж умер, воюя с этим человеком. А потом этот человек пять лет вёз моего сына в своём обозе. Он не спросил нас, КТО мы. Он спросил, СКОЛЬКО нас, — чтобы хлеба хватило. Весовщики спрашивают наоборот. Всё, что я знаю про Рим, — Рим это тот, кто спрашивает «сколько вас», а не «кто вы». ТАКОМУ Риму я открою ворота. Решайте, какому откроете вы.",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m8_ilva_voice.png"
      }
    },
    {
      "id": "e_108_spawn",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "spawn",
      "player": null,
      "units": [
        {
          "id": "militia_1",
          "hexKey": "5,2",
          "ownerId": "player_id_dark_green",
          "type": "unit_d6",
          "size": 6
        },
        {
          "id": "militia_2",
          "hexKey": "4,4",
          "ownerId": "player_id_dark_green",
          "type": "unit_d6",
          "size": 6
        },
        {
          "id": "militia_3",
          "hexKey": "5,3",
          "ownerId": "player_id_dark_green",
          "type": "unit_d6",
          "size": 5
        }
      ]
    },
    {
      "id": "entry_109_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,0",
          "unitId": "u_orange_7_-2_-1",
          "unitHexKey": "-2,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_110_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_5_-2_1",
          "unitHexKey": "-2,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_111_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_112_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_6_-3_1",
          "unitHexKey": "-3,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_113_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_114_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_115_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-3",
          "unitId": "u_violet_1_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_116_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-3",
          "unitId": "u_violet_0_2_-2",
          "unitHexKey": "2,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_117_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,-2",
          "unitId": "u_violet_2_1_-2",
          "unitHexKey": "1,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_118_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,-1",
          "unitId": "u_violet_3_1_-3",
          "unitHexKey": "1,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_119_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_120_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,3",
          "unitId": "militia_1",
          "unitHexKey": "5,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_121_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,3",
          "unitId": "militia_2",
          "unitHexKey": "4,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_122_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "militia_3",
          "unitHexKey": "5,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_123_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_124_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "despotism",
            "name": "Деспотизм",
            "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
            "implemented": true
          },
          "round": 4,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_125_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_126_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_127_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_128_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "patriotism",
            "name": "Патриотизм",
            "description": "Скидка на найм размера отрядов и Арсенал",
            "implemented": true
          },
          "round": 4,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_129_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_130_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_131_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_132_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_133_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_134_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_135_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_136_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_137_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_138_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_139_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_140_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_141_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 4,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_142_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true
          },
          "round": 4,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_143_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,0",
          "unitId": "u_orange_7_-2_-1",
          "unitHexKey": "-2,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_144_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_5_-2_1",
          "unitHexKey": "-2,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_145_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_146_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_6_-3_1",
          "unitHexKey": "-3,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_147_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_148_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_149_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-3",
          "unitId": "u_violet_1_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_150_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-3",
          "unitId": "u_violet_0_2_-2",
          "unitHexKey": "2,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_151_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,-2",
          "unitId": "u_violet_2_1_-2",
          "unitHexKey": "1,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_152_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,-1",
          "unitId": "u_violet_3_1_-3",
          "unitHexKey": "1,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_153_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_154_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,3",
          "unitId": "militia_3",
          "unitHexKey": "5,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_155_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,3",
          "unitId": "militia_1",
          "unitHexKey": "5,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_156_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "militia_2",
          "unitHexKey": "4,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_157_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_158_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "hegemonism",
            "name": "Гегемонизм",
            "description": "Бонус к доходу очков и урону в центре поля",
            "implemented": true
          },
          "round": 5,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_159_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_160_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_161_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_162_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "despotism",
            "name": "Деспотизм",
            "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
            "implemented": true
          },
          "round": 5,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_163_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_164_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_165_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_166_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_167_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_168_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_169_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_170_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_171_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_172_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_173_MOVE_UNIT",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "militia_1",
          "unitType": "unit_d6",
          "newHexKey": "3,2"
        }
      }
    },
    {
      "id": "entry_174_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "militia_1",
          "fromHexKey": "5,2",
          "toHexKey": "3,2",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_175_MOVE_UNIT",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "militia_2",
          "unitType": "unit_d6",
          "newHexKey": "3,3"
        }
      }
    },
    {
      "id": "entry_176_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "militia_2",
          "fromHexKey": "4,4",
          "toHexKey": "3,3",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_177_MOVE_UNIT",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "militia_3",
          "unitType": "unit_d6",
          "newHexKey": "4,3"
        }
      }
    },
    {
      "id": "entry_178_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "militia_3",
          "fromHexKey": "5,3",
          "toHexKey": "4,3",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_179_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_180_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_181_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 5,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_182_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true
          },
          "round": 5,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_183_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Там не только долги, Салоний. Там имена. Кто продавал, кто подписывал «Опеку», кто брал у Дома — по описи. Сожжём — не узнаем никогда.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m8_lucius_doubt.png"
      }
    },
    {
      "id": "e_184_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Узнаешь, легат, — и что делать будешь? Полгорода вешать? Имена — это месть, а бумага — ярмо. Жги, легат. Я двадцать лет при бумагах: бумага — она ярмо, ПОКА ЦЕЛА. А имена… имена я тебе и так скажу. Штук пять. Остальным дай жить с тем, что они помнят сами.",
        "characterName": "Салоний",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m8_salonius_firm.png"
      }
    },
    {
      "id": "e_185_spawn",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "spawn",
      "player": null,
      "units": [
        {
          "id": "militia_4",
          "hexKey": "0,-5",
          "ownerId": "player_id_dark_green",
          "type": "unit_d6",
          "size": 6
        },
        {
          "id": "militia_5",
          "hexKey": "1,-5",
          "ownerId": "player_id_dark_green",
          "type": "unit_d6",
          "size": 6
        }
      ]
    },
    {
      "id": "entry_186_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,0",
          "unitId": "u_orange_7_-2_-1",
          "unitHexKey": "-2,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_187_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_5_-2_1",
          "unitHexKey": "-2,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_188_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_189_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_6_-3_1",
          "unitHexKey": "-3,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_190_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_191_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_192_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-3",
          "unitId": "u_violet_1_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_193_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-3",
          "unitId": "u_violet_0_2_-2",
          "unitHexKey": "2,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_194_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,-2",
          "unitId": "u_violet_2_1_-2",
          "unitHexKey": "1,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_195_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,-1",
          "unitId": "u_violet_3_1_-3",
          "unitHexKey": "1,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_196_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_197_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,3",
          "unitId": "militia_2",
          "unitHexKey": "3,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_198_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,-6",
          "unitId": "militia_5",
          "unitHexKey": "1,-5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_199_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,-6",
          "unitId": "militia_4",
          "unitHexKey": "0,-5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_200_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,3",
          "unitId": "militia_3",
          "unitHexKey": "4,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_201_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "militia_1",
          "unitHexKey": "3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_202_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_203_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true
          },
          "round": 6,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_204_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_205_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_206_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_207_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true
          },
          "round": 6,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_208_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_209_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_210_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_211_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_212_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_213_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_214_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_215_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_216_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_217_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_218_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_219_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_220_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 6,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_221_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true
          },
          "round": 6,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_222_replica",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат. Жаль палату — там были документы редкой красоты. Но к делу: Дом готов обсудить… гармонизацию наших позиций в городе.",
        "characterName": "Вессано",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m8_vessano_polite.png"
      }
    },
    {
      "id": "e_223_replica",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Обсудим. Только считать сегодня буду я, синдик, — а ты поправляй. Долговой архив — пепел: закладные умерли, город тебе больше не должен. Наёмники Родоп — ушли и назначили тебе кровный счёт. Зерновые пути — под моей армией. Порты — под моими воротами. Предместья, что разгружали твои суда, — вон они, на стенах, посчитай сам. Гвардия — умирает за жалованье, а жалованье возишь морем, а море — теперь тоже моё. ИТОГО: каждая неделя «Опеки» стоит Дому восемьсот тысяч. Доходность — ноль. Я не предлагаю тебе уйти, синдик. Я показываю тебе твой же баланс.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m8_lucius_count.png"
      }
    },
    {
      "id": "e_224_replica",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…Семьсот сорок, легат. Не восемьсот. Вы забыли амортизацию гвардейского имущества. Дом Весов закрывает итальянскую позицию. Гарнизоны выйдут морем за десять дней, без боя. Приятно было наблюдать ваш рост, легат: четыре года назад вы не отличали закладную от купчей.",
        "characterName": "Вессано",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m8_vessano_defeat.png"
      }
    },
    {
      "id": "e_225_replica",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Четыре года назад ты скупал детей на дороге у Плаценции. Иди, синдик. И передай Дому: рынок закрыт. Мы выросли.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m8_lucius_count.png"
      }
    },
    {
      "id": "e_226_replica",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Все так говорят на первом расчёте, легат. Мы уйдём. Рынок вернётся. Рынок ВСЕГДА возвращается… Триста лет мы не входили в этот рынок. Знаете, во что нам встало такое терпение? Вот и растите быстрее. Мы подождём. Мы прекрасно умеем ждать.",
        "characterName": "Вессано",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m8_vessano_defeat.png"
      }
    },
    {
      "id": "entry_227_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,0",
          "unitId": "u_orange_7_-2_-1",
          "unitHexKey": "-2,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_228_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_5_-2_1",
          "unitHexKey": "-2,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_229_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_230_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_6_-3_1",
          "unitHexKey": "-3,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_231_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_232_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_233_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-3",
          "unitId": "u_violet_1_2_-3",
          "unitHexKey": "2,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_234_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-3",
          "unitId": "u_violet_0_2_-2",
          "unitHexKey": "2,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_235_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,-2",
          "unitId": "u_violet_2_1_-2",
          "unitHexKey": "1,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_236_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,-1",
          "unitId": "u_violet_3_1_-3",
          "unitHexKey": "1,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_237_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_238_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,3",
          "unitId": "militia_2",
          "unitHexKey": "3,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_239_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,-6",
          "unitId": "militia_5",
          "unitHexKey": "1,-5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_240_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,-6",
          "unitId": "militia_4",
          "unitHexKey": "0,-5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_241_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,3",
          "unitId": "militia_3",
          "unitHexKey": "4,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_242_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "militia_1",
          "unitHexKey": "3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_243_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_244_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true
          },
          "round": 7,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_245_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_246_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_247_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_248_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true
          },
          "round": 7,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_249_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_250_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_251_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_252_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_253_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_254_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_255_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_256_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_257_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_258_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_259_MOVE_UNIT",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "militia_4",
          "unitType": "unit_d6",
          "newHexKey": "0,-4"
        }
      }
    },
    {
      "id": "entry_260_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "militia_4",
          "fromHexKey": "0,-5",
          "toHexKey": "0,-4",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_261_MOVE_UNIT",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "militia_5",
          "unitType": "unit_d6",
          "newHexKey": "0,-5"
        }
      }
    },
    {
      "id": "entry_262_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "militia_5",
          "fromHexKey": "1,-5",
          "toHexKey": "0,-5",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_263_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_264_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_265_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 7,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_266_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true
          },
          "round": 7,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_267_replica",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Ну здравствуй, тёзка. Поднимайся, ступени скользкие — кровь я велел смыть, но эти лентяи… Мои когорты оружие сложили. Им перестали платить — а за идею в этом городе умираю, похоже, только я. Ирония: предатель — единственный идеалист… Предлагаю финал для летописей: напиши, что я удерживал город ДЛЯ тебя, — и мы оба герои. Историки любят, когда аккуратно.",
        "characterName": "Сулла",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m8_sulla_alone.png"
      }
    },
    {
      "id": "e_268_replica",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Историки напишут, как было, Луций. Как БЫЛО: ты продал ворота, я их купил обратно. Кровью. Не своей — вот что хуже всего.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m8_lucius_stern.png"
      }
    },
    {
      "id": "e_269_replica",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Значит, по-старому. Меч, тёзка. Я проиграл — я плачу́. Сделаю это красиво, обещаю: я всё делаю красиво.",
        "characterName": "Сулла",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m8_sulla_alone.png"
      }
    },
    {
      "id": "e_270_replica",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Нет. Рим больше не платит тебе, Луций. Даже смертью. Иди. Ворота на восток открыты, дорога — длинная. Успеешь понять, что я сейчас сделал.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m8_lucius_stern.png"
      }
    },
    {
      "id": "e_271_replica",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…Жестокий мальчик. Марк бы гордился — и НЕ ПОНЯЛ бы. Он был проще нас с тобой. Знаешь, что смешно, тёзка? Из нас двоих Рим по-настоящему ЛЮБИЛ только я. Ты его — строишь. Любить и строить — разные ремёсла. Прощай. Пойду посмотрю, что там на востоке за трава такая, о которой все молчат.",
        "characterName": "Сулла",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m8_sulla_east.png"
      }
    },
    {
      "id": "e_272_despawn",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "despawn",
      "playerColor": "violet"
    },
    {
      "id": "entry_273_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,0",
          "unitId": "u_orange_7_-2_-1",
          "unitHexKey": "-2,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_274_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_5_-2_1",
          "unitHexKey": "-2,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_275_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_276_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_6_-3_1",
          "unitHexKey": "-3,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_277_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_278_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_279_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_280_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,3",
          "unitId": "militia_2",
          "unitHexKey": "3,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_281_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,-6",
          "unitId": "militia_5",
          "unitHexKey": "0,-5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_282_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,-6",
          "unitId": "militia_4",
          "unitHexKey": "0,-4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_283_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,3",
          "unitId": "militia_3",
          "unitHexKey": "4,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_284_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "militia_1",
          "unitHexKey": "3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_285_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_286_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "despotism",
            "name": "Деспотизм",
            "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
            "implemented": true
          },
          "round": 8,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_287_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_288_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_289_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_290_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fortificationism",
            "name": "Фортификационизм",
            "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
            "implemented": true
          },
          "round": 8,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_291_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_292_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_293_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_294_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_295_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_296_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_297_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_298_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_299_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_300_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_301_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 8,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_302_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true
          },
          "round": 8,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_303_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,0",
          "unitId": "u_orange_7_-2_-1",
          "unitHexKey": "-2,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_304_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_5_-2_1",
          "unitHexKey": "-2,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_305_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_306_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_6_-3_1",
          "unitHexKey": "-3,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_307_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_308_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_309_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_310_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,3",
          "unitId": "militia_2",
          "unitHexKey": "3,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_311_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,-6",
          "unitId": "militia_5",
          "unitHexKey": "0,-5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_312_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,-6",
          "unitId": "militia_4",
          "unitHexKey": "0,-4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_313_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,3",
          "unitId": "militia_3",
          "unitHexKey": "4,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_314_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "militia_1",
          "unitHexKey": "3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_315_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_316_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fortificationism",
            "name": "Фортификационизм",
            "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
            "implemented": true
          },
          "round": 9,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_317_SET_HEX_TOKEN",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_HEX_TOKEN",
        "payload": {
          "key": "-3,2",
          "tokenType": "farm",
          "price": 3,
          "isCommiting": false,
          "isFreeAction": false
        }
      }
    },
    {
      "id": "entry_318_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_319_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_320_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_321_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true
          },
          "round": 9,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_322_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_323_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_324_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_325_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_326_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_327_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_328_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_329_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_330_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_331_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_332_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 9,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_333_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fortificationism",
            "name": "Фортификационизм",
            "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
            "implemented": true
          },
          "round": 9,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_334_replica",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Луций Аврелий Скавр! Сенат и народ Рима… сенат постановил поднести тебе диктатуру — на срок, какой ты сам определишь, для устроения государства…",
        "characterName": "Голос сената",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m8_senate.png"
      }
    },
    {
      "id": "e_335_replica",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "ИМПЕРАТОР!",
        "characterName": "Требоний",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m8_trebonius_shout.png"
      }
    },
    {
      "id": "e_336_replica",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Диктатуру — не приму. Диктатор — это господин на час, а у нас работы — на поколения… Титул, которым назвали меня солдаты, — приму. И второй приму, если дадите: не за победу — за долг. Отцом отечества назовите — и спрашивайте с меня, как с отца. Каждый день спрашивайте. Я видел, как умирает мир, который не отвечает на вопросы. Наш — будет отвечать. Начнём с простого: за стеной стоят те, кто все эти годы кормил, вёз и хоронил вместе с нами. Писарь! Первый эдикт: предместьям — право города. Рим — это те, кого мы впустили. Записывай, не смотри на сенат.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m8_lucius_emperor.png"
      }
    },
    {
      "id": "entry_337_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,0",
          "unitId": "u_orange_7_-2_-1",
          "unitHexKey": "-2,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_338_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_5_-2_1",
          "unitHexKey": "-2,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_339_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_340_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_6_-3_1",
          "unitHexKey": "-3,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_341_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_342_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,2",
          "unitId": "u_orange_5_-2_1",
          "unitHexKey": "-2,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_343_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_344_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_345_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,3",
          "unitId": "militia_2",
          "unitHexKey": "3,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_346_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,-6",
          "unitId": "militia_5",
          "unitHexKey": "0,-5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_347_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,-6",
          "unitId": "militia_4",
          "unitHexKey": "0,-4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_348_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,3",
          "unitId": "militia_3",
          "unitHexKey": "4,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_349_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "militia_1",
          "unitHexKey": "3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_350_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_351_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "hegemonism",
            "name": "Гегемонизм",
            "description": "Бонус к доходу очков и урону в центре поля",
            "implemented": true
          },
          "round": 10,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_352_replica",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Сорок человек в первой смене… Хорошее число. Приму как знак. Разреши заступать, префект Города заступает, легат.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m8_atilius_calm.png"
      }
    },
    {
      "id": "e_353_replica",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Казначеем? МЕНЯ?! Не искушай, легат, я тебя умоляю. Я — вор на покое. Покой дороже. Но книги ИХ я тебе дочитаю. Даром. Из любопытства.",
        "characterName": "Салоний",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m8_salonius_happy.png"
      }
    },
    {
      "id": "e_354_replica",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Складно говорит. Для молодой расы — почти не длинно… Ну что, человек-император. Понял теперь, почему мы смеялись?",
        "characterName": "Регин",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m8_regin_toast.png"
      }
    },
    {
      "id": "e_355_replica",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Начинаю. Вы смеялись, потому что вам запрещено плакать при чужих. И потому что мы думали, что победа — это конец.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m8_lucius_emperor.png"
      }
    },
    {
      "id": "e_356_replica",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…Ты смотри. Растут. За Новую эру, император. Она тебе не понравится. Но она — твоя.",
        "characterName": "Регин",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m8_regin_toast.png"
      }
    },
    {
      "id": "e_357_replica",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«…Теперь знаю, кому писал. Ансгару — и всем, кто после. Сын мой — по обозу, по клоаке, по праву тех восьмисот шагов: я не оставлю тебе писем. Заходи вечером — услышишь голос. Первый приказ отца отечества по дому: каша стынет. — Луций. Просто Луций.»",
        "characterName": "Из письма Луция",
        "side": "left",
        "characterImage": "/img/campaigns/humans/letters_lucius.png"
      }
    },
    {
      "id": "entry_358_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_359_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_360_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_361_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "hegemonism",
            "name": "Гегемонизм",
            "description": "Бонус к доходу очков и урону в центре поля",
            "implemented": true
          },
          "round": 10,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_362_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_363_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_364_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_365_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_366_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_367_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_368_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_369_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_370_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_371_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_372_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 10,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_373_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true
          },
          "round": 10,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_374_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,0",
          "unitId": "u_orange_7_-2_-1",
          "unitHexKey": "-2,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_375_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_5_-2_1",
          "unitHexKey": "-2,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_376_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,0",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_377_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_6_-3_1",
          "unitHexKey": "-3,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_378_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,-1",
          "unitId": "u_orange_4_0_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_379_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,2",
          "unitId": "u_orange_5_-2_1",
          "unitHexKey": "-2,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_380_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_381_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_382_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,3",
          "unitId": "militia_2",
          "unitHexKey": "3,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_383_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,-6",
          "unitId": "militia_5",
          "unitHexKey": "0,-5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_384_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,-6",
          "unitId": "militia_4",
          "unitHexKey": "0,-4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_385_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,3",
          "unitId": "militia_3",
          "unitHexKey": "4,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_386_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "militia_1",
          "unitHexKey": "3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_387_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_388_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true
          },
          "round": 11,
          "currentPlayerId": "player_id_dark_green",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_389_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_390_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_391_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_392_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fortificationism",
            "name": "Фортификационизм",
            "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
            "implemented": true
          },
          "round": 11,
          "currentPlayerId": "player_id_dark_green",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_393_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_394_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_395_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_396_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_397_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_398_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_399_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_400_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_401_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_402_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_403_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 11,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_404_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "dark_green",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "dark_green"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fortificationism",
            "name": "Фортификационизм",
            "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
            "implemented": true
          },
          "round": 11,
          "currentPlayerId": "player_id_dark_green",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    }
  ],
  "objectives": [
    {
      "id": "h8_cloaca",
      "type": "unit_reaches_hex",
      "params": {
        "hexKey": "-2,3"
      },
      "text": "Проведи когорту клоакой к решётке (обоз идёт тропой берега)",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h8_burn_chamber",
      "type": "destroy_building",
      "params": {
        "hexKey": "0,1"
      },
      "text": "Сожги палату Весов (катапульта, 4 попадания)",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h8_break_guard",
      "type": "destroy_all_enemy_units",
      "params": {
        "color": "orange"
      },
      "text": "Разбей гвардию Дома (фактории у Тибра)",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h8_capitol",
      "type": "capture_city",
      "params": {
        "centralHexKey": "1,-2"
      },
      "text": "Освободи Капитолий: за стеной обоз не кормит — считай размер отрядов",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h8_senate_word",
      "type": "survive_rounds",
      "params": {
        "rounds": 11
      },
      "text": "Дождись слова сената (раунд 11)",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h8_army_lost",
      "type": "lose_all_units",
      "params": {},
      "text": "Армия не должна погибнуть",
      "isMain": false,
      "isFailure": true
    }
  ]
};

export default mission;
